import './OHIFLogo.css';

import { Icon } from '@ohif/ui';
import React from 'react';

function OHIFLogo() {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="header-brand"
      href="http://ohif.org"
    >
      {/* Todo: Strax: Change logo later. Logo must in SVG format, we currently don't have */}
      <Icon name="ohif-logo" className="header-logo-image" />
      {/* Logo text would fit smaller displays at two lines:
       *
       * Open Health
       * Imaging Foundation
       *
       * Or as `OHIF` on really small displays
       */}
      {/* <Icon name="ohif-text-logo" className="header-logo-text" /> */}

      {/* Todo: Strax: Maybe we should use the SVG for the logo text as well. Just like above */}
      {/* - Strax:  Change logo text*/}
      <span>Strax DICOM Image Viewer</span>
    </a>
  );
}

export default OHIFLogo;
